import shopifyGenericDefaults from '../shopify-generic/config.js';
import {
  addCartDrawerEventListeners,
  updateCartDrawerRelatedProducts,
  updateCartDrawerVehicleWidget,
} from './cartDrawerHelper.js';
import { ConvermaxProductForm } from './productForm.js';
import { addPDPEventListeners, updatePDPRelatedProducts } from './productPageHelper.js';

const isProductPage = window.document.querySelector('body.product-template');

const updateVariantFitmentWidgets = (variantId) => {
  const productId = window.Convermax.Shopify?.getProductId?.();
  if (productId && variantId) {
    window.Convermax.updateVerifyFitmentWidget(productId, variantId);
    window.Convermax.updateFitmentTableWidget(productId, variantId);
  }
};

const InitFunc = () => {
  shopifyGenericDefaults.InitFunc?.();
  window.customElements.define('convermax-product-form', ConvermaxProductForm);
  addCartDrawerEventListeners();

  window.document
    .querySelector('product-info input[name="id"]')
    ?.addEventListener('change', ({ target: { value } }) => updateVariantFitmentWidgets(value));

  if (window.Convermax.Shopify.country !== 'US') {
    window.document.body.classList.add('cm_non-us');
  }
};

window.Convermax.handleProductOptionClick = (clickedButton, product, option) => {
  const item = clickedButton.closest('.cm_product-item');
  const imageSrc = product.resizeImage(option.image);
  item
    .querySelectorAll('.cm_product-item__option-value')
    .forEach((pill) => pill.setAttribute('aria-pressed', pill === clickedButton));
  item.querySelectorAll('.cm_product-item__image').forEach((image) => image.setAttribute('src', imageSrc));
  item
    .querySelectorAll('a[href]')
    .forEach((link) => link.setAttribute('href', window.Convermax.getVehicleUrl(option.url)));
};

const forceVehicleDialog = () => {
  const { getCookie, setCookie, isStorageAllowed } = window.Convermax.helpers;
  const cookieName = 'convermax_vehicle_popup';
  window.setTimeout(() => {
    if (
      !isStorageAllowed(cookieName) ||
      window.Convermax.getVehicleList?.()?.length > 0 ||
      getCookie(cookieName)
    ) {
      return;
    }

    window.Convermax.openVehicleDialog();
    setCookie(cookieName, 'true', new Date(Date.now() + 7 * 24 * 60 * 60 * 1000));
  }, 15000);
};

const AfterInit = () => {
  shopifyGenericDefaults.AfterInit?.();

  setTimeout(() => forceVehicleDialog(), 0);

  if (isProductPage) {
    addPDPEventListeners();
  }
};

function onVehicleSelected(vehicle) {
  if (window.document.querySelector('cart-drawer')?.classList.contains('active')) {
    setTimeout(() => {
      updateCartDrawerRelatedProducts(vehicle);
      updateCartDrawerVehicleWidget(vehicle);
    }, 100);
  }

  if (isProductPage) {
    setTimeout(() => {
      updatePDPRelatedProducts(vehicle);
    }, 100);
  }
}

function onVehicleDiscarded() {
  if (window.document.querySelector('cart-drawer')?.classList.contains('active')) {
    setTimeout(() => {
      updateCartDrawerRelatedProducts();
      updateCartDrawerVehicleWidget();
    }, 100);
  }

  if (isProductPage) {
    setTimeout(() => {
      updatePDPRelatedProducts();
    }, 100);
  }
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  InitFunc,
  AfterInit,
  doAutocompleteRedirect: true,
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    onVehicleSelected,
    onVehicleDiscarded,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['Garage', 'MobileGarage', 'HeaderVehicleWidget', 'VehicleWidgetDialog'].includes(w.name),
    ),
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'Garage'),
      doNotRedirectOnVehicleSelect: true,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'MobileGarage'),
      doNotRedirectOnVehicleSelect: true,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'HeaderVehicleWidget'),
      template: 'fitmentSearch/homeVehicleWidget',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'VehicleWidgetDialog'),
      isAlwaysColumnLayout: true,
    },
  ],
};
